import styled from '../../../../lib/theme';

const SuggestedProvidersStyle = styled('div')`
  display: flex;
  flex-direction: column;

  button {
    display: block;
    text-align: left;
    margin: 1rem 0;
    width: 100%;
    border-radius: 6px;
    color: ${({ theme }) =>
      theme.suggestedResponseColor || theme.primaryAccentColor} !important;
  }
`;

export const ProviderName = styled('div')`
  font-weight: bold;
`;

export default SuggestedProvidersStyle;
